module.exports = __webpack_public_path__ + "static/img/utility.de4e054.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/utility.svg
// module id = EZeX
// module chunks = 4